import React, { useEffect } from 'react';
import { connect } from 'react-redux';

import { makeStyles, Typography } from '@material-ui/core';

import makePath from '../../utils/makePath';
import { TextInput } from '../EditorFormElements';

import { FormFieldWrapper } from '../Global';
import { setItem } from '../../actions';


const preset = {
  "100-100" : "Too easy!",
  "99-95": "You know your stuff, way to go!",
  "94-80": "Nice work, but you can do better.",
  "79-50": "There's work to be done, but we're here to help.",
  "49-0": "There's work to be done, but we're here to help."
}

const ranges = [{
    name:"100-100", 
    label:"100",
  },
  {
    name: "99-95",
    label: "95-99",
  },
  {
    name: "94-80",
    label: "80-94",
  },
  {
    name: "79-50",
    label: "50-79",
  },
  {
    name: "49-0",
    label: "0-49",
  }];

const useStyles = makeStyles(theme => ({
  fieldset: {
    padding: 0,
    margin: 0,
    border: 'none'
  },
  pseudolabel: {
    ...theme.overrides.MuiFormLabel.root,
    ...theme.overrides.MuiInputLabel.outlined,
    transform: 'translate(0px, 0px) scale(0.75)',
    transformOrigin: 'left',
    marginTop: 10,
    width: '100%',
  },
  textInput: {
    '& .MuiInputBase-root': {
      marginTop: -6,
    }
  }
}))

export const CustomFeedback = connect(null, { setItem })(
  React.memo( ( { given = {}, path, setItem, ...props } ) => {
    
    path = makePath(path,'responses');

    const classes = useStyles();

    useEffect(() => {
      setItem(makePath(path,'preset'), preset);
    }, [path,setItem])

    return (
      <>
        {props.hideHeader ? '' :
          <h5 className="form-section-header">Score Feedback</h5>
        }
        
        {ranges.map((range,index) => (
          <React.Fragment key={index}>

            {/* Heading */}
            <div className={classes.pseudolabel}>Score & Feedback</div>
            
            {/* "Canned response" feedback */}
            <Typography>{range.label} | {preset[range.name]}</Typography>
            
            {/* Custom feedback */}
            <FormFieldWrapper>
                <TextInput 
                  className={classes.textInput}
                  fullWidth
                  multiline
                  rows={4}
                  placeholder="Enter custom text that relates to the topic and references remediation to display with the score feedback."
                  key={index}
                  name={range.name}
                  given={given.custom ? given.custom[range.name] : ''}
                  path={makePath(path,'custom')}
                  max={120}
                  inputProps={{
                    'aria-label':range.label + ' custom feedback',
                  }}
                />
              
            </FormFieldWrapper>

          </React.Fragment>
        ))}
      </>
    )


  })
)